// PageTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTracker = () => {
    const location = useLocation();
    useEffect(() => {
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search + location.hash,
            page_title: location.pathname,
            page_search: location.search,
            page_hash: location.hash,
        });
    }, [location]);
    return null; // This component doesn't render anything
};

export default PageTracker;